import { GetInitialDataCtx, WidgetProps } from "../../contracts/widget"
import { calendarWidgetConfig, CalendarWidgetConfig } from "./config"
import { WidgetProvider } from "../../providers/widget"
import { CalendarWidgetContent } from "./components/CalendarWidgetContent"
import "./calendar.css"
import { useMemo } from "react"
import { parseWidgetConfig } from "@homerunner-next/widget-core/schema"

export const getInitialData = async ({ options, feedId, widgetId }: GetInitialDataCtx<CalendarWidgetConfig>) => {
    return {}
}

export default function CalendarWidget({ options, feedId, widgetId, resolvedTheme, data }: WidgetProps<CalendarWidgetConfig>) {
    const parsedOptions = useMemo(() => parseWidgetConfig(calendarWidgetConfig, options), [options])
    return (
        <WidgetProvider options={parsedOptions} feedId={feedId} widgetId={widgetId} resolvedTheme={resolvedTheme} widgetType="calendar" data={data ?? {}}>
            <CalendarWidgetContent />
        </WidgetProvider>
    )
}
